export default __webpack_public_path__ + "static/media/agra1.53158fbe.jpg";